import {
  DeleteOutlined,
  EditOutlined,
  PlusCircleOutlined,
  PlusOutlined,
  QuestionCircleOutlined,
} from "@ant-design/icons";

import {
  Button,
  Card,
  Col,
  DatePicker,
  Divider,
  Drawer,
  Form,
  Input,
  InputNumber,
  Row,
  Select,
  Space,
  Table,
  Tooltip,
} from "antd";
import React, { useEffect, useRef } from "react";
import { useClient } from "../../Context/ClientContext";
import LedgerService, {
  SearchLedgerByGroupsTypes,
} from "../../Services/LedgerService";
import { dayjs } from "../../../Utilities/dayjs";
import { AssetPurType, CalcMethod, ChildAsset, PmtMethod } from "./AssetModel";
import AddLedger from "../Master/Ledger/AddLedger";
import {
  ITCEligibility_Type,
  ITCEligibilityTypeOptions,
  Party_Tax,
} from "../../Services/VoucherServices";
import { AssetPurchase_Type } from "../../Services/FixedAssetsServiceNew";
import {
  handleDecimalValues,
  handleInputFocus,
  Utils,
} from "../../../Utilities/Utils";
import { CompanyGSTTypes } from "../../../Types/CommonConstants";
import { ColumnsType } from "antd/es/table";
import AssetChildDetail from "./AssetChildDetail";
import { notificationContext } from "../../Common/PageRoute";

const AssetInvoiceDetail = ({
  open,
  onCancel,
  singleAssetType,
  isDepreciable,
  depMethod,
  refNumber,
  selKey,
  setInvoiceDetail,
  oldPurchaseType,
  invoiceDetaildata,
  assetName,
  assetId,
}: any) => {
  // const autoCompleteRef = useRef<any>(null);
  const { currentClient, companySettings } = useClient();
  const { openNotification } = React.useContext(notificationContext);
  const [selChildIndex, setSelChildIndex] = React.useState<number>(selKey ?? 0);
  const [payLedgers, setPayLedgers] = React.useState<any>([]);
  const [trigger, setTrigger] = React.useState(false);
  const [partyLedgers, setPartyLedgers] = React.useState<any>([]);
  const [childform] = Form.useForm();
  const [addLedgerResponse, setAddLedgerResponse] = React.useState<any>(null);
  // const [childAssetCount, setChildAssetCount] = React.useState<number>(
  //   invoiceDetaildata?.childAssetDetail?.length ?? 1
  // );

  const [childAssetDetail, setChildAssetDetail] = React.useState<ChildAsset[]>(
    []
  );
  const [paymentMode, setPaymentMode] = React.useState<any>();
  const [paymentLedgerDetail, setPaymentLedgerDetail] = React.useState<{
    balance: number;
    partyType: Party_Tax;
  }>();
  // const [assetPrice, setAssetPrice] = React.useState<number>(0);
  const [openChildDrawer, setOpenChildDrawer] = React.useState<boolean>(false);
  // const [childAssetData, setChildAssetData] = React.useState<ChildAsset[]>([]);
  const [assetPurDate, setAssetPurDate] = React.useState<any>(undefined);
  // const [voucherDate, setVoucherDate] = React.useState<string>();
  const [fyPeriod, setFYPeriod] = React.useState<any>({
    from: dayjs(companySettings?.period?.from),
    to: dayjs(companySettings?.period?.to),
  });

  const [openModel, setOpenModel] = React.useState<{
    type: string;
    param: any;
  }>({
    type: "",
    param: {},
  });

  const editDate = invoiceDetaildata?.voucherRefs?.id
    ? invoiceDetaildata?.date
    : null;

  // const gstOption = companySettings?.setting?.gstDetails?.gst;
  const gstOption = companySettings?.gsts;

  const onPaymentModeChange = (selValue: PmtMethod) => {
    childform.setFieldValue("purPaymentLedger", "");
    childform.setFieldValue("purPartyLedger", "");
    if (selValue === PmtMethod.bank) {
      LedgerService.getLedgersByGroupName(
        currentClient?.id!,
        SearchLedgerByGroupsTypes.BankOnly
      ).then((res: any) => {
        setPayLedgers(res);
      });
    }
    if (selValue === PmtMethod.fullCredit) {
      LedgerService.getLedgersByGroupName(
        currentClient?.id!,
        SearchLedgerByGroupsTypes.PartiesOnly
      ).then((res: any) => {
        setPartyLedgers(
          res.filter(
            (led: any) =>
              led.gstType !== CompanyGSTTypes.Overseas &&
              led.gstType !== CompanyGSTTypes.DeemedExportImport &&
              led.gstType !== CompanyGSTTypes.SEZ
          )
        );
      });
    }
    if (selValue === PmtMethod.cash) {
      LedgerService.getLedgersByGroupName(
        currentClient?.id!,
        SearchLedgerByGroupsTypes.CashOnly
      ).then((res: any) => {
        setPayLedgers(res);
      });
    }
    if (selValue === PmtMethod.partialCredit) {
      LedgerService.getLedgersByGroupName(
        currentClient?.id!,
        SearchLedgerByGroupsTypes.BankAndCash
      ).then((res: any) => {
        setPayLedgers(res);
      });
      LedgerService.getLedgersByGroupName(
        currentClient?.id!,
        SearchLedgerByGroupsTypes.PartiesOnly
      ).then((res: any) => {
        setPartyLedgers(
          res.filter(
            (led: any) =>
              led.gstType !== CompanyGSTTypes.Overseas &&
              led.gstType !== CompanyGSTTypes.DeemedExportImport &&
              led.gstType !== CompanyGSTTypes.SEZ
          )
        );
      });
    }
    setPaymentMode(selValue);
  };
  const handlePaymentLedgerSelect = (value: string) => {
    var selParty = payLedgers.find((led: any) => led.id === value);
    setPaymentLedgerDetail({
      balance: selParty?.balance,
      partyType: selParty?.partyOrTax,
    });
  };
  const handleAddChild = () => {
    childform.validateFields().then(() => {
      let maxVal = childAssetDetail?.reduce(
        (acc: number, rec: any) => (acc > rec.key ? acc : rec.key),
        0
      );
      let childLength = childAssetDetail ? maxVal + 1 : 0;
      setSelChildIndex(childLength);
      setOpenChildDrawer(true);
    });
  };
  useEffect(() => {
    if (addLedgerResponse) {
      const exists = partyLedgers.some(
        (option: any) => option.id === addLedgerResponse.id
      );
      if (exists) {
        childform.setFieldValue("partyLedger", {
          key: addLedgerResponse?.id,
          value: addLedgerResponse?.id,
          label: addLedgerResponse?.ledgerName,
          title: "",
        });
        // setPartyLedgers(addLedgerResponse?.id);
        setAddLedgerResponse(null);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [partyLedgers]);

  useEffect(() => {
    let selValue = childform.getFieldValue("purPayMethod");
    onPaymentModeChange(selValue);
  }, [trigger]);

  React.useEffect(() => {
    if (invoiceDetaildata) {
      setPaymentMode(invoiceDetaildata?.purPayMethod!);
      onPaymentModeChange(invoiceDetaildata?.purPayMethod!);
      // setVoucherDate(invoiceDetaildata?.voucherDate);
      setAssetPurDate(invoiceDetaildata?.date);
      setChildAssetDetail(invoiceDetaildata?.childAssetDetail ?? []);
      childform.setFieldsValue({
        ...invoiceDetaildata,
        gst: invoiceDetaildata?.gst && {
          value: invoiceDetaildata?.gst?.id,
          // key: invoiceDetaildata?.gst?.rate,
          label: invoiceDetaildata?.gst?.name,
          title: "",
        },
        taxCredit: invoiceDetaildata?.taxCredit,
        date: invoiceDetaildata?.date
          ? dayjs(invoiceDetaildata?.date!)
          : undefined,
        voucherDate:
          invoiceDetaildata?.voucherDate &&
          dayjs(invoiceDetaildata?.voucherDate).unix() > 1
            ? dayjs(invoiceDetaildata?.voucherDate!)
            : undefined,
        purPayDate: invoiceDetaildata?.purPayDate
          ? dayjs(invoiceDetaildata?.purPayDate!)
          : undefined,
        purchaseType: oldPurchaseType
          ? AssetPurType.OldPurchase
          : AssetPurType.NewPurchase,
      });
    }
  }, [invoiceDetaildata]);

  useEffect(() => {
    if (assetId) {
      let selPayLedger = invoiceDetaildata?.purPaymentLedger;
      if (selPayLedger) {
        let selPayLedgerDetail = payLedgers?.find(
          (led: any) => led.id === selPayLedger
        );
        setPaymentLedgerDetail({
          balance: selPayLedgerDetail?.balance,
          partyType: selPayLedgerDetail?.partyOrTax,
        });
      }
    }
  }, [payLedgers]);
  const childAssetColumns: ColumnsType<ChildAsset> = [
    {
      title: "S.No.",
      dataIndex: "childAssetNumber",
      key: "childAssetNumber",
      render: (val: string, _, index: number) => index + 1,
    },
    {
      title: "Child Asset Name",
      dataIndex: "childAssetName",
      key: "childAssetName",
    },
    {
      title: "Child Asset Number",
      dataIndex: "childAssetNumber",
      key: "childAssetNumber",
      align: "center",
    },
    {
      title: "Base Price",
      dataIndex: "price",
      // key: "price",
      align: "right",
      render: (val: string) => Utils.getFormattedNumber(val),
    },
    {
      title: "Depreciation Start Date",
      dataIndex: "depreciationStartDate",
      key: "depreciationStartDate",
      render: (val: string) =>
        val !== undefined && dayjs(val).unix() > 1
          ? dayjs(val).format("DD/MM/YYYY")
          : undefined,
    },
    {
      title: "Action",
      dataIndex: "key",
      render: (val: any) => (
        <>
          <Button
            onClick={() => {
              setSelChildIndex(val);
              setOpenChildDrawer(true);
            }}
            icon={<EditOutlined />}
            size="small"
          />
          <Button
            style={{ marginLeft: "5px" }}
            onClick={() => {
              setChildAssetDetail((prev: any) =>
                prev.filter((child: any) => child.key !== val)
              );
            }}
            icon={<DeleteOutlined style={{ color: "red" }} />}
            size="small"
          />
        </>
      ),
    },
  ];

  return (
    <>
      <Drawer
        width={"60vw"}
        title="Asset Purchase Detail"
        onClose={() => onCancel(false)}
        maskClosable={false}
        open={open}
        extra={
          <Space>
            <Button
              onClick={() => {
                setSelChildIndex(0);
                childform.resetFields();
                onCancel(false);
              }}
            >
              Cancel
            </Button>
            <Button
              type="primary"
              onClick={() => {
                if (childAssetDetail?.length === 0) {
                  openNotification(
                    "error",
                    "No child asset detail is entered."
                  );
                  return false;
                }
                let totalPrice = childAssetDetail.reduce(
                  (acc: number, rec: any) => acc + rec.price,
                  0
                );

                if (
                  paymentLedgerDetail?.partyType === Party_Tax.BanknCash &&
                  totalPrice >
                    (assetId
                      ? paymentLedgerDetail?.balance +
                        invoiceDetaildata?.prevTotalPrice
                      : paymentLedgerDetail?.balance)
                ) {
                  openNotification(
                    "error",
                    "Insufficient balance in selected payment ledger."
                  );
                  return false;
                }
                childform.validateFields().then((val) => {
                  setInvoiceDetail((prevValues: any) => {
                    console.log("Invoice detail before Submit: ", prevValues);

                    let newValues = [...prevValues];

                    let givenDate;

                    if (
                      invoiceDetaildata?.voucherRefs?.id &&
                      dayjs(val.date).isSame(dayjs(editDate), "day")
                    ) {
                      givenDate = editDate;
                    } else {
                      givenDate = new Date(val.date);
                      const currentTime = new Date();

                      // Set the time part of givenDate to match currentTime
                      givenDate?.setHours(
                        currentTime.getHours(),
                        currentTime.getMinutes(),
                        currentTime.getSeconds(),
                        currentTime.getMilliseconds()
                      );
                    }

                    let formValues = {
                      ...val,
                      childAssetDetail: childAssetDetail,
                      price: childAssetDetail?.reduce(
                        (acc: number, rec: any) => acc + rec?.price,
                        0
                      ),
                      qty: childAssetDetail?.reduce(
                        (acc: number, rec: any) => acc + 1,
                        0
                      ),
                      date: dayjs(givenDate).toISOString(),
                      voucherDate: val?.voucherDate
                        ? dayjs(val?.voucherDate).toISOString()
                        : undefined,
                      purPayDate: val?.purPayDate
                        ? dayjs(val?.purPayDate).toISOString()
                        : undefined,
                    };
                    let selGST = gstOption?.find(
                      (gst: any) => gst.id === formValues?.gst
                    );
                    let totalChildAssetsValue = childAssetDetail.reduce(
                      (acc: number, rec: any) => acc + rec.price,
                      0
                    );
                    // selChildIndex < newValues.length
                    newValues.some((val: any) => val.key === selKey)
                      ? (newValues = newValues.map(
                          (ent: any, index: number) => {
                            return ent.key === selKey
                              ? {
                                  ...ent,
                                  ...formValues,
                                  purPartyLedger:
                                    formValues.purPartyLedger !== null
                                      ? formValues.purPartyLedger
                                      : null,
                                  purPaymentLedger:
                                    formValues.purPaymentLedger !== null
                                      ? formValues.purPaymentLedger
                                      : null,
                                  gst: { ...selGST },
                                  // gst: formValues?.gst?.value && {
                                  //   id: formValues?.gst?.value,
                                  //   rate: formValues?.gst?.key,
                                  //   name: formValues?.gst?.label,
                                  // },
                                  totalValue:
                                    (totalChildAssetsValue *
                                      (selGST?.rate + 100)) /
                                    100,
                                  // key: index,
                                }
                              : {
                                  ...ent,
                                  // residualValue:
                                  //   depMethod === CalcMethod.StraightLine
                                  //     ? formValues?.residualValue
                                  //     : 0,
                                  gst: { ...selGST },
                                  totalValue:
                                    (totalChildAssetsValue *
                                      (selGST?.rate + 100)) /
                                    100,

                                  // gst: formValues?.gst?.value && {
                                  //   id: formValues?.gst?.value,
                                  //   rate: formValues?.gst?.key,
                                  //   name: formValues?.gst?.label,
                                  // },
                                  // voucherDate: dayjs(voucherDate).toISOString(),
                                };
                          }
                        ))
                      : newValues.push({
                          ...formValues,
                          // residualValue:
                          //   depMethod === CalcMethod.StraightLine
                          //     ? formValues?.residualValue
                          //     : 0,
                          gst: { ...selGST },
                          totalValue:
                            (totalChildAssetsValue * (selGST?.rate + 100)) /
                            100,

                          // gst: formValues?.gst?.value && {
                          //   id: formValues?.gst?.value,
                          //   rate: formValues?.gst?.key,
                          //   name: formValues?.gst?.label,
                          // },
                          key: newValues.length,
                          // voucherDate: dayjs(voucherDate).toISOString(),
                        });
                    console.log("Invoice detail after Submit: ", newValues);
                    return newValues;
                  });
                  onCancel();
                });
              }}
            >
              Save Detail
            </Button>
          </Space>
        }
      >
        <Form
          name="invoiceData"
          labelCol={{ span: 24 }}
          wrapperCol={{ span: 24 }}
          style={{ overflow: "scrollY" }}
          autoComplete="off"
          form={childform}
          layout="vertical"
          size="middle"
          initialValues={{
            // qty: childAssetCount,
            // childAssetDetail: [{}],
            taxCredit: ITCEligibility_Type.Available,
            purchaseType: oldPurchaseType
              ? AssetPurType.OldPurchase
              : AssetPurType.NewPurchase,
          }} //onFinishFailed={}
        >
          <Row gutter={6}>
            <Col lg={6} md={6}>
              <Form.Item
                name="date"
                label="Purchase Date"
                rules={[
                  {
                    required: true,
                    message: "Purchase date required",
                  },
                ]}
                className="inputboxmb"
              >
                <DatePicker
                  // ref={autoCompleteRef}
                  style={{ width: "100%" }}
                  disabledDate={(current: any) =>
                    oldPurchaseType ? false : current < dayjs(fyPeriod.from)
                  }
                  allowClear={true}
                  format={"DD/MM/YYYY"}
                  onChange={(val) => setAssetPurDate(dayjs(val).toISOString())}
                />
              </Form.Item>
            </Col>
            <Col lg={6} md={6}>
              <Form.Item
                name="voucherDate"
                className="inputboxmb"
                label={
                  <Space>
                    Voucher Date
                    <Tooltip
                      title="Please input the Voucher Date in case you want to provide specific date for Voucher Entry else Purchase date will be Voucher Date."
                      placement="top"
                      color="#4b5b95"
                    >
                      <QuestionCircleOutlined />
                    </Tooltip>
                  </Space>
                }
              >
                <DatePicker
                  style={{ width: "100%" }}
                  disabledDate={(current: any) =>
                    childform.getFieldValue("date") < fyPeriod.from
                      ? current < dayjs(fyPeriod.from)
                      : current <
                        dayjs(childform.getFieldValue("date")).startOf("day")
                  }
                  allowClear={true}
                  format={"DD/MM/YYYY"}
                  // onChange={(value: any) =>
                  //   value === undefined
                  //     ? setVoucherDate("")
                  //     : setVoucherDate(value.toISOString())
                  // }
                />
              </Form.Item>
            </Col>
            <Col lg={6} md={6}>
              <Form.Item
                name="invNumber"
                label="Invoice No."
                className="inputboxmb"
                rules={[
                  {
                    required: true,
                    message: "Invoice No. is required",
                  },
                  {
                    min: 3,
                    max: 30,
                    message: "Length must be between 3 and 30",
                  },
                ]}
              >
                <Input />
              </Form.Item>
            </Col>
            <Col lg={6} md={6}>
              <Form.Item
                name="purchaseType"
                label="Purchase Type"
                className="inputboxmb"
              >
                <Select
                  disabled={true}
                  placeholder="Please select"
                  options={[
                    {
                      label: "New Purchase",
                      value: AssetPurchase_Type.NewPurchase,
                      title: "",
                    },
                    {
                      label: "Old Purchase",
                      value: AssetPurchase_Type.OldPurchase,
                      title: "",
                    },
                  ]}
                />
              </Form.Item>
            </Col>
            <Col lg={6} md={6} style={{ display: "none" }}>
              <Form.Item
                hidden={true}
                name="price"
                className="inputboxmb"
                label={
                  <Space>
                    Purchase Price
                    <Tooltip
                      title="Please input the base purchase price for the Input Tax Credit, else include GST with the base price"
                      placement="top"
                      color="#4b5b95"
                    >
                      <QuestionCircleOutlined />
                    </Tooltip>
                  </Space>
                }
                // rules={[
                //   {
                //     required: true,
                //     message: "Please provide price of asset",
                //   },
                //   {
                //     validator: (_, value) => {
                //       if (value && value < 0) {
                //         return Promise.reject("Price can't be negative.");
                //       }
                //       return Promise.resolve();
                //     },
                //   },
                // ]}
              >
                <Input
                  min={0}
                  type="number"
                  className="textEnd"
                  // onChange={(val: any) => setAssetPrice(val?.target?.value)}
                />
              </Form.Item>
            </Col>
            {currentClient?.gstType === CompanyGSTTypes.Regular && (
              <>
                <Col lg={6} md={6}>
                  <Form.Item
                    name="taxCredit"
                    label="Tax Credit"
                    className="inputboxmb"
                  >
                    <Select
                      //className="inputboxsize"
                      disabled={gstOption == null ? true : false}
                      placeholder="Please select"
                      options={ITCEligibilityTypeOptions}
                    />
                  </Form.Item>
                </Col>
                <Col lg={6} md={6}>
                  <Form.Item
                    name="gst"
                    label="GST"
                    className="inputboxmb"
                    rules={[
                      {
                        required: true,
                        message: "Please select GST Rate",
                      },
                    ]}
                  >
                    <Select
                      placeholder="Select GST Rate"
                      disabled={gstOption === null ? true : false}
                      style={{ marginBottom: "3px" }}
                      options={gstOption?.map((gst: any, index: number) => ({
                        key: index,
                        value: gst.id,
                        label: gst.name,
                        title: "",
                      }))}
                    />
                  </Form.Item>
                </Col>
              </>
            )}
            <Col lg={6} md={6}>
              <Form.Item
                name="purPayMethod"
                label="Payment Mode"
                className="inputboxmb"
                rules={[
                  {
                    required: true,
                    message: "Payment mode is required",
                  },
                ]}
              >
                <Select
                  //className="inputboxsize"
                  style={{ marginBottom: "3px" }}
                  placeholder="Please select payment mode"
                  onChange={onPaymentModeChange}
                  options={[
                    {
                      value: PmtMethod.bank,
                      label: "Bank",
                      title: "",
                    },
                    {
                      value: PmtMethod.cash,
                      label: "Cash",
                      title: "",
                    },
                    {
                      value: PmtMethod.fullCredit,
                      label: "Credit",
                      title: "",
                    },
                    {
                      value: PmtMethod.partialCredit,
                      label: "Partial Payment",
                      title: "",
                    },
                  ]}
                />
              </Form.Item>
            </Col>
            {paymentMode === PmtMethod.partialCredit && (
              <>
                <Col lg={6} md={6}>
                  <Form.Item
                    name="partiallyPaidAmount"
                    label="Partially Paid Amount"
                    className="inputboxmb"
                    rules={[
                      {
                        required: true,
                        message: "Partially paid amount is required",
                      },
                    ]}
                  >
                    <InputNumber
                      //className="inputboxsize"
                      type="number"
                      min={1}
                      max={999999999}
                      precision={2}
                      style={{ marginBottom: "3px", width: "100%" }}
                      placeholder="Enter amount"
                      onFocus={(e) => {
                        handleInputFocus(e, childform);
                      }}
                      onKeyPress={handleDecimalValues}
                    />
                  </Form.Item>
                </Col>
              </>
            )}
            {paymentMode !== PmtMethod.fullCredit && (
              <>
                <Col lg={6} md={6}>
                  <Form.Item
                    name="purPayDate"
                    label="Payment Date"
                    rules={[
                      {
                        required: true,
                        message: "Payment date required",
                      },
                    ]}
                    className="inputboxmb"
                  >
                    <DatePicker
                      allowClear={false}
                      format={"DD/MM/YYYY"}
                      style={{ width: "100%" }}
                      disabled={
                        paymentMode === PmtMethod.fullCredit ? true : false
                      }
                      disabledDate={(current) =>
                        current < dayjs(assetPurDate).startOf("day")
                      }
                    />
                  </Form.Item>
                </Col>
              </>
            )}

            {(paymentMode === PmtMethod.partialCredit ||
              paymentMode === PmtMethod.cash ||
              paymentMode === PmtMethod.bank) && (
              <>
                <Col lg={6} md={6}>
                  <Form.Item
                    name="purPaymentLedger"
                    label="Payment Ledger"
                    className="inputboxmb"
                    rules={[
                      {
                        required: true,
                        message: "Payment ledger is required",
                      },
                    ]}
                    help={
                      <div>
                        Balance:{" "}
                        <span style={{ fontWeight: "bold" }}>
                          {Math.abs(paymentLedgerDetail?.balance || 0) +
                            (Utils.getNumber(paymentLedgerDetail?.balance) === 0
                              ? ""
                              : Utils.getNumber(paymentLedgerDetail?.balance) >
                                0
                              ? " Dr"
                              : " Cr")}
                        </span>
                      </div>
                    }
                  >
                    <Select
                      showSearch
                      filterOption={(input, option) =>
                        (option?.label?.toString() ?? "")
                          .toLowerCase()
                          .includes(input.toLowerCase())
                      }
                      style={{ marginBottom: "3px" }}
                      onSelect={(val: string) => {
                        handlePaymentLedgerSelect(val);
                      }}
                      options={payLedgers?.map((value: any) => ({
                        value: value?.id,
                        label: value?.ledgerName.concat(
                          value?.aliasName
                            ? `${" (" + value?.aliasName + ")"}`
                            : ""
                        ),
                        title: "",
                      }))}
                      dropdownRender={(supplierOptions) => (
                        <>
                          {supplierOptions}
                          <Divider style={{ margin: "5px 0px" }} />
                          <Button
                            style={{ width: "100%" }}
                            icon={<PlusOutlined />}
                            type="link"
                            onClick={() => {
                              setOpenModel({
                                type: "addLedger",
                                param: {
                                  open: true,
                                  ledgerByGroupsType:
                                    paymentMode === PmtMethod.partialCredit
                                      ? SearchLedgerByGroupsTypes.BankAndCash
                                      : paymentMode === PmtMethod.bank
                                      ? SearchLedgerByGroupsTypes.BankOnly
                                      : SearchLedgerByGroupsTypes.CashOnly,
                                  showName:
                                    paymentMode === PmtMethod.partialCredit
                                      ? "Cash / Bank"
                                      : paymentMode === PmtMethod.bank
                                      ? "Bank"
                                      : "Cash",
                                },
                              });
                            }}
                          >
                            New Ledger
                          </Button>
                        </>
                      )}
                    />
                  </Form.Item>
                </Col>
              </>
            )}

            {(paymentMode === PmtMethod.partialCredit ||
              paymentMode === PmtMethod.bank) && (
              <>
                <Col lg={6} md={6}>
                  <Form.Item
                    name="purPayRef"
                    label="Payment Reference"
                    className="inputboxmb"
                    rules={[
                      {
                        min: 0,
                        max: 20,
                        message: "Length must be between 0 and 20",
                      },
                    ]}
                  >
                    <Input
                      disabled={
                        paymentMode === PmtMethod.fullCredit
                          ? true
                          : paymentMode === PmtMethod.cash
                          ? true
                          : false
                      }
                    />
                  </Form.Item>
                </Col>
              </>
            )}
            {(paymentMode === PmtMethod.partialCredit ||
              paymentMode === PmtMethod.fullCredit) && (
              <>
                <Col lg={6} md={6}>
                  <Form.Item
                    name="purPartyLedger"
                    label="Party Ledger"
                    className="inputboxmb"
                    rules={[
                      {
                        required: true,
                        message: "Party ledger is required",
                      },
                    ]}
                  >
                    <Select
                      showSearch
                      filterOption={(input, option) =>
                        (option?.label?.toString() ?? "")
                          .toLowerCase()
                          .includes(input.toLowerCase())
                      }
                      style={{ marginBottom: "3px" }}
                      options={partyLedgers?.map((value: any) => ({
                        value: value?.id,
                        label: value?.ledgerName.concat(
                          value?.aliasName
                            ? `${" (" + value?.aliasName + ")"}`
                            : ""
                        ),
                        title: "",
                      }))}
                      dropdownRender={(supplierOptions) => (
                        <>
                          {supplierOptions}
                          <Divider style={{ margin: "5px 0px" }} />
                          <Button
                            style={{ width: "100%" }}
                            icon={<PlusOutlined />}
                            type="link"
                            onClick={() => {
                              setOpenModel({
                                type: "addLedger",
                                param: {
                                  open: true,
                                  ledgerByGroupsType:
                                    SearchLedgerByGroupsTypes.PartiesOnly,
                                  showName: "Party",
                                },
                              });
                              // setEditParty({ id: "" });
                            }}
                          >
                            New Ledger
                          </Button>
                        </>
                      )}
                    />
                  </Form.Item>
                </Col>
              </>
            )}
          </Row>
          <Row justify={"space-between"}>
            <Col lg={4} md={4}>
              {/* <Form.Item
                name="qty"
                label="Quantity"
                className="inputboxmb"
                rules={[
                  {
                    required: true,
                    message: "Quantity is required",
                  },
                ]}
              >
                <InputNumber
                  min={1}
                  max={100}
                  disabled={singleAssetType}
                  value={childAssetCount}
                  onChange={(val: any) => {
                    if (val < 1) {
                      val = 1;
                    }
                    setChildAssetCount(val);
                  }}
                  style={{ width: "100%" }}
                  onFocus={(e) => {
                    handleInputFocus(e, childform);
                  }}
                />
              </Form.Item> */}
            </Col>
            <Col
              style={{
                justifyContent: "flex-end",
                alignContent: "flex-end",
                textAlign: "right",
                padding: "4px",
              }}
            >
              {singleAssetType && childAssetDetail?.length > 0 ? (
                <></>
              ) : (
                <Button onClick={handleAddChild}>
                  <PlusCircleOutlined /> Add Child Detail
                </Button>
              )}
            </Col>
          </Row>
          <Row>
            <Col span={24}>
              <Table
                columns={childAssetColumns}
                dataSource={childAssetDetail?.filter(
                  (child: any) => child.price > 0
                )}
              ></Table>
            </Col>
          </Row>
        </Form>
        {openChildDrawer && (
          <AssetChildDetail
            onClose={() => setOpenChildDrawer(false)}
            open={openChildDrawer}
            setOpenChildDrawer={setOpenChildDrawer}
            isDepreciable={isDepreciable}
            depMethod={depMethod}
            refNumber={refNumber}
            singleAssetType={singleAssetType}
            selKey={selChildIndex}
            purchaseDate={assetPurDate}
            // setInvoiceDetail={setInvoiceDetail}
            setChildAssetDetail={setChildAssetDetail}
            childAssetDetail={childAssetDetail}
            oldPurchaseType={oldPurchaseType}
            invoiceDetaildata={invoiceDetaildata}
            assetName={assetName}
          />
        )}
      </Drawer>
      {openModel.type === "addLedger" && (
        <AddLedger
          openDrawer={openModel?.param.open}
          id={""}
          setOpenDrawer={() => setOpenModel({ type: "", param: "" })}
          setTrigger={setTrigger}
          type={openModel?.param?.ledgerByGroupsType}
          setAddLedgerResponse={setAddLedgerResponse}
          // setRefresh={setRefresh}
          defaultGroup={openModel?.param?.defaultGroup}
          showName={openModel?.param?.showName}
        />
      )}

      {/* {isModelOpen && (
        <AddLocationModal
          onCancel={() => setIsModelOpen(false)}
          isModelOpen={isModelOpen}
          id={""}
          setRefresh={setRefresh}
        />
      )} */}
    </>
  );
};

export default AssetInvoiceDetail;
